import { NotifyHelper } from "../../../helpers/toast";
import { eChuongTrinhDaoTaoActionsObj } from "../../action-types/chuong-trinh-dao-tao/IChuongTrinhDaoTaoActions";
import { generateActionForKey, generateActions } from "../generateActions";


export const chuongTrinhDaoTaoActions = {
    ...generateActions(eChuongTrinhDaoTaoActionsObj, "CHUONG_TRINH_DAO_TAO"),
    ...generateActionForKey(eChuongTrinhDaoTaoActionsObj, "CHUONG_TRINH_DAO_TAO",
        "LOAD_ERROR", (m) => NotifyHelper.Error(m)
    ),
}